// TODO(WEB): Switch to three-platform lib like react-native-dotenv
// https://www.npmjs.com/package/react-native-dotenv

interface ConfigEnv {
  getConstants: () => string[]
}

const configEnv: ConfigEnv = {
  getConstants: () => [],
}

export default configEnv
